'use strict';

function fBacktotop () {
    const oTrigger = document.querySelector('.js-backtotop');
    
    oTrigger.addEventListener('click', function () {
        window.scrollTo({
            'behavior': 'smooth',
            'left': 0,
            'top': 0
        });
    });
}